export default __webpack_public_path__ + "static/media/free.93550923.svg";